import {
  resourceState,
  resourceMutations,
  resourceGetters,
  resourceActions,
} from '@/store/utils/resource';
import { CONTACT_REQUESTS } from '@/store/entities/schema_types';
import { contactRequestsClient as client } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters(CONTACT_REQUESTS),
  actions: {
    ...resourceActions,
    async load(ctx, { query = {} }) {
      try {
        const response = await client.list(query);

        const { data, meta } = response;

        const contactRequestIds = await ctx.dispatch(
          'entities/persistEntities',
          { type: CONTACT_REQUESTS, data },
          { root: true }
        );

        ctx.commit('setIds', contactRequestIds);
        ctx.commit('setMeta', meta);

        return Promise.resolve({ contactRequestIds, meta });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
    async read(ctx, { id, query = {} }) {
      try {
        const response = await client.read(id, query);

        const { data } = response;

        await ctx.dispatch(
          'entities/persistEntities',
          { type: CONTACT_REQUESTS, data },
          { root: true }
        );

        return Promise.resolve(true);
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
    async update(ctx, { id, formData }) {
      try {
        const response = await client.update(id, mapKeysToSnakeCase(formData));

        await ctx.dispatch(
          'entities/persistEntities',
          { type: CONTACT_REQUESTS, data: response.data },
          { root: true }
        );

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async destroy(ctx, id) {
      try {
        await client.destroy(id);

        await ctx.commit('entities/removeEntity', { type: CONTACT_REQUESTS, id }, { root: true });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
